import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

enum CURRENCY {
    EUR = 'EUR',
}

type CellPriceProps<TData, TValue> = CellContext<TData, TValue> & {
    currency?: CURRENCY;
};

export function CellPrice<TData, TValue>({ getValue, currency = CURRENCY.EUR }: CellPriceProps<TData, TValue>) {
    const value = getValue() as number;
    const { formatNumber } = useIntl();

    return (
        <span>
            {formatNumber((value ?? 0) / 100, {
                style: 'currency',
                currency: currency,
            })}
        </span>
    );
}
